import * as React from "react";
import {Fragment} from "react";
import IdleTimer from 'react-idle-timer';
import { 
    ApplicationState, 
    UserStoreState, 
    UserStatus, 
    UserSessionToken
} from "../user/UserStore";
import {connect} from "react-redux";
import {UserActions} from "../user/UserActions";
import {ConfirmModal} from "../util/ConfirmModal";

const TOKEN_REFRESH_INTERVAL = 10 * 60 * 1000;
const IDLE_TIMEOUT_VALUE = 60 * 60 * 1000;
const TIME_TO_AUTO_LOGOUT = 30 * 1000;

interface State {
    showIdleForm : boolean;
    userSessionToken? : UserSessionToken;
    timeoutValue: number;
    timerIdleText: string;
}

const mapStateToProps = (state : ApplicationState) : UserStoreState => {
    return state.user;
};


export class IdleTimeoutView extends React.Component<UserStoreState,State> {

    private idleTimer: any;
    private timer: any;
    private logoutTimer: any;
    
    constructor(props : UserStoreState) {
        super(props);
        this.state = { 
            showIdleForm : false, 
            userSessionToken: props.userToken,
            timeoutValue: IDLE_TIMEOUT_VALUE,
            timerIdleText: "onIdle not triggered.", 
        };

        this.idleTimer = null;
        this.timer = null;
        this.logoutTimer = null;
    }

    componentDidMount(){
        console.log("Timer mounted");
        this.timer = setInterval(()=>this.refreshSession(), TOKEN_REFRESH_INTERVAL);
    }

    componentWillUnmount(){
        console.log("Timer unmounted");
        clearInterval(this.timer);
    }
    componentDidUpdate(prevProps: Readonly<UserStoreState>, prevState: Readonly<State>, snapshot?: any): void {
        if(prevProps.userToken !== this.props.userToken){
            this.setState({userSessionToken :this.props.userToken});
        }
    }

    onPrompt = () =>{
        console.log("On promptWas called")
    }

    onAction = () => {}
    
    onActive = () => {
        let msg = "You're active!";
        console.log(msg);
        clearTimeout(this.logoutTimer);
        if (!document.hasFocus()) { this.setState({showIdleForm: false}) }
    }
    
    onIdle = () => {
        let msg = "You've been idle! " + new Date().toISOString();
        console.log(msg);
        this.logoutTimer = setTimeout(()=>{  this.logout(); }, TIME_TO_AUTO_LOGOUT);
        this.setState({ timerIdleText: msg, showIdleForm: true })
    }

    refreshSession(): void {
        console.log("Refresh session " + new Date().toISOString());
        clearTimeout(this.logoutTimer);
        if(this.props.status !== UserStatus.LOGGED_IN){ return; }
        if(this.state.showIdleForm) { this.setState({showIdleForm: false});}
        new UserActions().refreshToken();
    }

    logout() : void {
        console.log("Check if logout " + new Date().toISOString());
        if (!this.idleTimer || this.idleTimer.isIdle()){
            console.log("Will logout " + new Date().toISOString());
            clearInterval(this.timer);
            new UserActions().logout();
        }
    }

    render(){
        if(this.props.status !== UserStatus.LOGGED_IN) {
            return <div/>;
        }

        return <Fragment>
            <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                /* */
                crossTab={{
                    type: 'localStorage',
                    emitOnAllTabs: true
                }}
                /* */
                timeout={this.state.timeoutValue}
                promptTimeout={10000}
                onPrompt={this.onPrompt}
                onAction={this.onAction}
                onActive={this.onActive}
                onIdle={this.onIdle}>
            </IdleTimer>
            <ConfirmModal
                show={this.state.showIdleForm}
                heading="Idle Timeout"
                description={`Please click Ok before the next ${TIME_TO_AUTO_LOGOUT/1000} seconds to stay logged in`}
                okLabel="OK"
                onOk={
                    this.refreshSession.bind(this)
                }
                onCancel={this.logout.bind(this)}
            />
        </Fragment>
    }
}

export default connect(mapStateToProps)(IdleTimeoutView);
